import {Component} from '@angular/core';
import {NbIconLibraries} from '@nebular/theme';
import {svgPack} from '@shared/svg';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'test-system';

    constructor(private iconLibraries: NbIconLibraries) {
        const pack = {};
        Object.keys(svgPack)
            .forEach((key) => {
                pack[key] = svgPack[key];
            });
        this.iconLibraries.registerSvgPack('st', pack);
        this.iconLibraries.setDefaultPack('st');
    }
}
